import React, { useEffect, useState } from 'react';
import { Phone, ChevronDown } from 'lucide-react';
const HeroSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const backgroundImages = ['https://images.unsplash.com/photo-1593784991095-a205069470b6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80', 'https://images.unsplash.com/photo-1558346490-a72e53ae2d4f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80', 'https://images.unsplash.com/photo-1593121925328-369cc8459c08?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex => prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1);
    }, 5000); // Change image every 5 seconds
    return () => clearInterval(interval);
  }, []);
  const scrollToContact = () => {
    const contactForm = document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div id="top" className="relative w-full bg-gray-900 overflow-hidden" data-id="element-197">
      {/* Background image with overlay - now rotating */}
      <div className="absolute inset-0 z-0" data-id="element-198">
        {backgroundImages.map((image, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ${index === currentImageIndex ? 'opacity-100' : 'opacity-0'}`} data-id="element-199">
            <img src={image} alt={`I75 Audio & Video, LLC showcase ${index + 1}`} className="object-cover w-full h-full opacity-50" data-id="element-200" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/50" data-id="element-201"></div>
          </div>)}
      </div>
      {/* Content container */}
      <div className="relative z-10 container mx-auto px-4 py-28 md:py-36 flex flex-col items-center text-center" data-id="element-202">
        {/* Centered text content */}
        <div className="w-full max-w-3xl text-white" data-id="element-203">
          {/* Logo with adjusted styling for the shield-shaped logo */}
          <div className="flex justify-center mb-4" data-id="element-204">
            <div className="overflow-hidden bg-transparent" data-id="element-205">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/v7yfSfpEBAhNGcxDkT5ZNW/i75_transparent_PNG.png" alt="i75 Audio & Video LLC - Technology & Structured Cabling" style={{
              height: '250px',
              width: '250px'
            }} className="object-contain" data-id="element-206" />
            </div>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold leading-tight mb-4" data-id="element-207">
            Smart AV & Network Solutions for Home & Business
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200" data-id="element-208">
            Custom installations by experienced pros — Home Theater, Camera
            Systems, Whole Home Audio & Commercial AV.
          </p>
          <div className="flex flex-wrap justify-center gap-4 mb-8" data-id="element-209">
            <button onClick={scrollToContact} className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-300 inline-flex items-center" data-id="element-210">
              Get a Free Quote
              <ChevronDown className="ml-2 h-5 w-5" data-id="element-211" />
            </button>
            <a href="tel:2392038333" className="inline-flex items-center text-xl font-bold text-blue-300 hover:text-blue-200 transition-colors" data-id="element-212">
              <Phone className="w-5 h-5 mr-2" data-id="element-213" />
              Call Now: 239-203-8333
            </a>
          </div>
          {/* Image indicators */}
          <div className="flex justify-center space-x-2 mt-8" data-id="element-214">
            {backgroundImages.map((_, index) => <button key={index} onClick={() => setCurrentImageIndex(index)} className={`w-3 h-3 rounded-full transition-colors ${index === currentImageIndex ? 'bg-white' : 'bg-gray-500'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-215" />)}
          </div>
        </div>
      </div>
    </div>;
};
export default HeroSection;